import { useEffect, useState } from 'react'; // Added useState for local dashboard data
import {  useNavigate } from 'react-router-dom';
import { Spinner, Alert } from 'flowbite-react'; // Added Progress and Alert

import PageHeading from '../../../components/PageHeading';


const NewFeaturePage = () => {
    const navigate = useNavigate();

    const [loadingData, setLoadingData] = useState(true); // State for dashboard data loading

    // Effect to check authentication status and set page title on component mount
    useEffect(() => {
        document.title = 'CPA - New Feature';

        setLoadingData(false);

    }, [navigate]);

    return (
        <div className="p-4 sm:p-6 lg:p-8"> {/* Adjusted padding for better spacing */}

            <PageHeading value="New Features" />
    

            {loadingData ? (
                <div className="flex justify-center items-center h-64">
                    <Spinner size="xl" />
                    <p className="ml-3 text-lg text-gray-500 dark:text-gray-400">Loading ...</p>
                </div>
            ) : (
                <div className="grid gap-6">
                    <p>This feature will be realesing soon , Stay tuned.</p>

                </div>
            )}
        </div>
    );
};

export default NewFeaturePage;